var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("panel-competition-form-box", { staticClass: "mab16" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "register-layout" }, [
            _c(
              "div",
              { staticClass: "register-layout__main" },
              [
                _c("label", { staticClass: "mab8" }, [
                  _vm._v("Możliwość rejestracji anonimowej"),
                ]),
                _vm._l(_vm.anonymousOptions, function (option) {
                  return _c("panel-input-base-radio", {
                    key: option.value,
                    attrs: {
                      value: _vm.anonymous,
                      name: "register-anonymous",
                      option: option,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("update:anonymous", $event)
                      },
                    },
                  })
                }),
              ],
              2
            ),
            _c("div", { staticClass: "register-layout__side" }, [
              _c("p", { staticClass: "register-layout__hint" }, [
                _vm._v(
                  " Uczestnicy mogą mieć możliwość ukrycia swoich danych na listach startowej oraz wyników. "
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("panel-competition-form-box", { staticClass: "mab16" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "register-layout" }, [
            _c("div", { staticClass: "register-layout__main" }, [
              _c("div", { staticClass: "form__headline mab8" }, [
                _vm._v("Pola dodatkowe w formularzu rejestracyjnym"),
              ]),
              _c("p", [
                _vm._v(
                  " Jeśli chcesz pozyskać od uczestnika dane, które nie znajdują się w podstawowym formularzu rejestracyjnym, dodaj dodatkowe pytania, na które uczestnik odpowie podczas rejestracji. "
                ),
              ]),
            ]),
            _c("div", { staticClass: "register-layout__side" }, [
              _c("p", { staticClass: "register-layout__hint" }, [
                _vm._v(
                  " Podstawowe dane rejestracyjne to: Imię i nazwisko, data urodzenia, płeć, miejscowość, kraj, adres email, telefon, klub. "
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._l(_vm.inputs, function (input, index) {
        return _c("panel-competition-register-input-item", {
          key: input._key,
          attrs: {
            value: input,
            index: index,
            total: _vm.inputs.length,
            classifications: _vm.classifications,
            "type-options": _vm.typeOptions,
            "validation-options": _vm.validationOptions,
          },
          on: {
            input: function ($event) {
              return _vm.onInputChange(index, $event)
            },
            remove: function ($event) {
              return _vm.$emit("remove", index)
            },
            copy: function ($event) {
              return _vm.$emit("copy", index)
            },
            "move-up": function ($event) {
              return _vm.$emit("move-up", index)
            },
            "move-down": function ($event) {
              return _vm.$emit("move-down", index)
            },
          },
        })
      }),
      _c(
        "div",
        { staticClass: "register-layout__actions mat16 mab16" },
        [
          _c(
            "base-button",
            {
              attrs: { btn2: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("add")
                },
              },
            },
            [_vm._v("UTWÓRZ PYTANIE DODATKOWE")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "register-layout__actions register-layout__actions--end mat16 mab64",
        },
        [
          _c(
            "base-button",
            {
              staticClass: "register-layout__save",
              attrs: { btn1: "", loading: _vm.saving, disabled: _vm.saving },
              on: {
                click: function ($event) {
                  return _vm.$emit("save")
                },
              },
            },
            [_vm._v(" Zapisz ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }